import { useTranslation } from 'react-i18next';
import { StyledRequestSubmitted } from './RequestSubmitted.styles';
import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';

const CASE_ID = '1234567';

export const RequestSubmitted = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledRequestSubmitted className="request-submitted">
      <SvgIcon name="circleCheck" className="request-submitted__icon" />
      <h2 className="request-submitted__title">{t('service.requestSubmitted.title', { caseId: CASE_ID })}</h2>
      <p className="request-submitted__subtitle">{t('service.requestSubmitted.subtitle')}</p>
    </StyledRequestSubmitted>
  );
};
